import { render, staticRenderFns } from "./UrlListComponent.vue?vue&type=template&id=29d4e9a8&"
import script from "./UrlListComponent.vue?vue&type=script&lang=js&"
export * from "./UrlListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports